/* tslint:disable */
/* eslint-disable */
/**
 * Datixo API
 * API endpoints for communication with Datixo.
 *
 * The version of the OpenAPI document: v1.0.0
 * Contact: api@datixo.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface GoogleSearchConsoleUrlInspectionInput
 */
export interface GoogleSearchConsoleUrlInspectionInput {
    /**
     * 
     * @type {Array<string>}
     * @memberof GoogleSearchConsoleUrlInspectionInput
     */
    urls?: Array<string>;
}

/**
 * Check if a given object implements the GoogleSearchConsoleUrlInspectionInput interface.
 */
export function instanceOfGoogleSearchConsoleUrlInspectionInput(value: object): value is GoogleSearchConsoleUrlInspectionInput {
    return true;
}

export function GoogleSearchConsoleUrlInspectionInputFromJSON(json: any): GoogleSearchConsoleUrlInspectionInput {
    return GoogleSearchConsoleUrlInspectionInputFromJSONTyped(json, false);
}

export function GoogleSearchConsoleUrlInspectionInputFromJSONTyped(json: any, ignoreDiscriminator: boolean): GoogleSearchConsoleUrlInspectionInput {
    if (json == null) {
        return json;
    }
    return {
        
        'urls': json['urls'] == null ? undefined : json['urls'],
    };
}

export function GoogleSearchConsoleUrlInspectionInputToJSON(json: any): GoogleSearchConsoleUrlInspectionInput {
    return GoogleSearchConsoleUrlInspectionInputToJSONTyped(json, false);
}

export function GoogleSearchConsoleUrlInspectionInputToJSONTyped(value?: GoogleSearchConsoleUrlInspectionInput | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'urls': value['urls'],
    };
}

